<template>
  <div v-if="icon" class="weather-wrapper flex flex-row">
    <div class="w-70 h-70 overflow-hidden mr-6"><img :src="icon" /></div>
    <div>
      <div class="degrees">{{temp}} °C</div>
      <div class="wind">
        <div class="flex flex-row">
          <div>
            {{windSpeed}} m/s
          </div>
          <div class="relative">
            <svg :style="`rotate: ${svgRotation}deg`" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.91752 8.67777L13.4705 11.4542L11.5836 8.68599L9.71551 5.94276L11.505 3.30254C12.5059 1.88253 13.5424 0.582304 13.3335 0.622229C13.0804 0.656321 3.74433 4.12413 0.563198 5.34651C0.27811 5.44386 0.0576123 5.51964 0.177122 5.62538C0.252409 5.72529 3.3164 7.12301 6.91752 8.67777Z" fill="#0F417C"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";

const WEATHER_RELOAD_INTERVAL = 60000 * 5;
const OPENWEATHER_API_KEY = 'df24d4ff8884f4d7335b23ace4b25e87';

export default {
  data() {
    return {
      icon: null,
      temp: null,
      windSpeed: null,
      windDeg: null,
      windDirection: null,
      svgRotation: null,
    }
  },
  mounted() {
    this.reloadData();
    setTimeout(this.reloadData, WEATHER_RELOAD_INTERVAL);
  },
  methods: {
    async reloadData() {

      const lat = 54.63;
      const lng = 25.28;

      const { data } = await axios.get(`https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&units=metric&appid=${OPENWEATHER_API_KEY}`);

      this.icon = `https://openweathermap.org/img/wn/${data.weather[0].icon}@2x.png`;
      this.temp = Math.round(data.main.temp);
      this.windSpeed = data.wind.speed;
      this.windDeg = data.wind.deg;
      this.svgRotation = data.wind.deg - 270; // icon is already rotated 270 degrees
      setTimeout(this.reloadData, WEATHER_RELOAD_INTERVAL);
    }
  }
}
</script>

<style lang="postcss">
  .weather-wrapper {
    text-align: right;

    img {
      height: 8rem;
      margin-top: 5px;
      object-fit: contain;
    }

    .degrees {
      font-size: 3.4rem;
      font-weight: 700;
    }
    .wind {
      font-size: 1.6rem;
      font-weight: 700;

      svg {
        margin-top: 0.7rem;
        margin-left: 0.3rem;
      }
    }
  }
</style>
